<template>
	<div class="content-contrainer">
		<div class="content-banner" :class="__lang"></div>
		<div class="content-menu-list">
			<div class="main-box">
				<router-link v-for="(item, index) in childrenMenu.child" :key="index" :to="item.link" class="content-menu-list-item" active-class="active">{{item.name}}</router-link>
			</div>
		</div>
		
		<block :title="lang[__lang].field">
			<div class="main-box">
				<el-row :gutter="50" style="margin-top: 50px;">
					<el-col :span="10">
						<el-image style="width: 100%;" :src="content.imgUrl"></el-image>
					</el-col>
					<el-col :span="14">
						<div class="filed-desc">
							<div>
								<el-image style="width: 37px;" :src="require('../../assets/img/dl.png')"></el-image>
							</div>
							<p>{{content.feildDesc}}</p>
							<div style="text-align: right;">
								<el-image style="width: 37px;" :src="require('../../assets/img/dr.png')"></el-image>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</block>
		
		<block v-if="t_menu" :title="lang[__lang].laboratory" style="margin-top: 100px;" type="bgr">
			<div class="main-box">
				<div class="labor-checkbox" :class="__lang">
					<a href="javascript:;" @click="checkLabor(item.id)" v-for="(item, index) in t_menu.child" :key="index" :class="'labor-checkbox-btn '+(item.id===activeLabor?'active':'')">{{item.name}}</a>
				</div>
				<div class="labor-content">
				<div class="text-center">
					<el-image style="width: 200px;" :src="content[activeLabor].thumb"></el-image>
				</div>
				<h4 class="text-center" style="font-size: 18px;">{{content[activeLabor].title}}</h4>
					<div style="margin-top: 40px;" v-for="(item, index) in content[activeLabor].content" :key="index">
						<div style="font-size: 18px;margin-bottom: 5px;">{{item.title}}</div>
						<div v-html="item.content"></div>
					</div>
				</div>
			</div>
		</block>
	</div>
</template>

<script>
import { navbar, researchData } from "../../data.js";
import lang from "../../lang.js";
import block from "../../components/block.vue";
export default {
	name: "dataCenter",
	components:{
		block
	},
	data() {
		return {
			lang,
			researchData,
			activeLabor:""
		};
	},
	computed:{
    menus(){
      return navbar({
        lang:this.$route.params.lang || 'zh-CN'
      })
    },
		childrenMenu(){
			return this.menus.find(v=>v.id=="research");
		},
		t_menu(){
      console.log(this.childrenMenu.child);
      const menu = this.childrenMenu.child.find(v=>v.id==this.$route.name);
      console.log(menu.child[0]);
      if (menu.child[0]) {
        this.update('activeLabor', menu.child[0].id);
        return menu;
      }
			return "";
		},
		__lang(){return this.$route.params.lang},
    content(){
      const lang = this.__lang;
      const name = this.$route.name;
      return researchData[lang][name]||{};
    }
	},
	methods:{
    update(key, value) {
      this[key] = value;
    },
		checkLabor(id) {
			this.activeLabor = id;
		}
	}
};
</script>

<style lang="less" scoped>
.content-contrainer {
	padding-bottom: 60px;
}
.content-banner {
	margin-top: 70px;
	width: 100%;
	height: 340px;
	background: url(../../assets/img/banner_keyan.jpg) center center no-repeat;
  &.en {
    background: url(../../assets/img/banner_keyan_en.png) center center no-repeat;
  }
}
.content-menu-list {
	border-bottom: 1px solid #999;
	overflow: hidden;
	.content-menu-list-item {
		text-decoration: none;
		color: #222;
		float: left;
		line-height: 60px;
		font-size: 16px;
		padding: 0 19px;
		&.active{
			color: #d22c1d;
		}
		&.active:after {
			display: block;
			content: " ";
			width: 60%;
			height: 4px;
			background-color: #d22c1d;
			margin: auto;
		}
	}
}
.filed-desc {
	padding: 40px 0;
	line-height: 30px;
	font-size: 18px;
}
.labor-checkbox {
	margin-bottom: 40px;
	.labor-checkbox-btn {
		display:inline-block;
		line-height: 46px;
		height: 46px;
		padding: 0 30px;
		border-radius: 23px;
		background-color: #eee;
		margin-right: 40px;
		color: #222;
		text-decoration: none;
		&.active{
			color: #fff;
			background-color: #d22c1d;
		}
		&:last-child{
			margin-right: 0;
		}
	}
	&.en {
		.labor-checkbox-btn {
			padding: 0 18px;
			&:not(:last-child){
				margin-right: 20px;
			}
		}
	}
}
</style>
